import { connect } from 'react-redux';

import { fetchPublication } from 'client/ducks/publications/actions';
import { getPublication, isLoading } from 'client/ducks/publications/selectors';
import { State } from 'client/store';

import Publication, { DispatchProps, StateProps } from './publication';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';

function mapStateToProps(state: State): StateProps {
    return {
        data: getPublication(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = { fetchPublication };

const component = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(Publication) as any;

component.asyncFetchData = ({ dispatch, match }: AsyncFetchDataProps) => {
    dispatch(fetchPublication(match.params.id));
};

export default component;
